/* eslint-disable */
import React, { useEffect, useState, useRef, Fragment } from "react";
// import { Col, Container, Row, Stack, Button, Form, Image, Card, Accordion } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import * as types from "../../constants/CrmActionTypes";
import { Listbox, Transition, Dialog } from '@headlessui/react'
// import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'
import "../crmComponents/Leadtabs.css";
import Emails from "./tab-components/Emails";
import { Link, Outlet } from "react-router-dom";
import { useParams, useNavigate } from "react-router-dom";
import {
  appUserActivity,
  editUserData,
  fetchUpdatedMeeting,
  updateLeadsStage,
} from "../../redux/actions/crmActions";
import { useDispatch, useSelector } from "react-redux";
import dashboard from "../../assets/crm/dashboard.png";
import moment from "moment";
import AddMail from "./AddMail";
import Loading from "../assetLibComponents/Loading";
import { Disclosure } from "@headlessui/react";
import { ChevronUpIcon, ArrowPathIcon, ChevronDownIcon, HandThumbUpIcon, PhoneIcon, UserCircleIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { UserIcon } from "@heroicons/react/24/outline";
import { Mixpanel } from "../../Mixpanel";
import TabLeadDetail from "../TabLeadDetail";

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const LeadDetail = (props) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const cancelButtonRef = useRef(null)
  const navigate = useNavigate();
  const userDetails = useSelector(
    (state) => state.crmLeads.userActivityDetails
  );
  const user_detail_left = useSelector(
    (state) => state.crmLeads.userActivityDetails?.data?.lead_response
  );
  const isLoading = useSelector((state) => state.crmLeads.loading);

  // const taskList = useSelector((state) => state.crmLeads.tasksList);

  const authToken = props.authToken;
  // const pageFrom = props.pageFrom;

  // const [stage, setStage] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [capturedFields, setCapturedFields] = useState([]);
  const [captureData, setCaptureData] = useState(null);
  const [tabName, setTabName] = useState("Lead");
  const [insightData, setInsightData] = useState(null);
  const [companyName, setCompanyName] = useState("");
  const [openRightBar, setOpenRightBar] = useState(false);
  const [refreshFlag, setRefreshFlag] = useState(false);
  const [designation, setDesignation] = useState("");
  const [companyWebsite, setCompanyWebsite] = useState("");
  const [phoneNum, setPhoneNum] = useState("");
  const [editDetail, setEditDetail] = useState(false);
  const [userData, setUserData] = useState([]);
  const [stage, setStage] = useState("");

  const tabs =  (captureData?.company_website !== "" || captureData?.company !== "") ? [
      { name: "Lead", href: "/Lead-Management", current: true },
      { name: "Account", href: "/Account", current: false },
    ]
    :
    [
      { name: "Lead", href: "/Lead-Management", current: true },
    ]
  
  const getChars = (str) => {
    if (str === "") {
      return;
    }
    const firstLetters = str
      .split(" ")
      .slice(0, 2)
      .map((word) => word[0])
      .join("")
      .toUpperCase();
    return firstLetters;
  };

  useEffect(() => {
    if (id !== undefined) {
      dispatch(appUserActivity(authToken, id , null));
    }
    props.pageTypeHandler("Lead Mangement");
  }, []);
  
  useEffect(() => {
    if (id !== undefined) {
      dispatch(appUserActivity(authToken, id ,editDetail));
    }
  }, [window.location.pathname,editDetail])
  
  useEffect(() => {
    if (userDetails?.data?.insight_data) {
      setInsightData(userDetails?.data?.insight_data)
      setCaptureData(userDetails?.data?.insight_data?.captured_fields);
      const capturedFields = userDetails?.data?.insight_data?.captured_fields; 
      const arrayOfObjects = [];
      for (const key in capturedFields) {
          if (capturedFields.hasOwnProperty(key)) {
              const value = capturedFields[key];
              arrayOfObjects.push({ key, value });
          }
      }
      setCapturedFields(arrayOfObjects); 
    }
  }, [userDetails])
  
  
  useEffect(() => {
    Mixpanel.track("Accessed Lead.")
    return () => {
      dispatch({ type: types.USER_ACTIVITY_DETAILS, payload: null });
      dispatch({ type: types.DETAIL_UPDATED_DATA, payload: null });
    };
  }, []);

  useEffect(async() => {
    setName(userDetails?.data?.response?.name);  
    if (user_detail_left?.length > 0) {
      await user_detail_left.map(async(obj, o_ind) => {
        if (obj?.options?.length > 0 && obj.values !== null) {
          const objData = await obj.options.find(option => option.id == obj.values)
          obj.values = objData;
        }
        return obj
      })
    }    
    setUserData(user_detail_left);
  }, [user_detail_left]);

  const updateStage = (e) => {
    setStage(e);
    if (userDetails?.data?.leadstages) {
      let stageNum = userDetails.data.leadstages.filter((item) => {
        if (e === item.lead_stage) {
          return item.id;
        }
      });
      dispatch(updateLeadsStage(authToken, stageNum[0].id, id));
    }
  };

  const handleRoute = () => {
    navigate("/Lead-Management");
  };
  
  const handleEditorStatus = (value) => {
    setEditDetail(value);
  }
  
  const backToDetail = () => {
    setName(userDetails?.data?.response?.name);
    // setUserData(userDetails?.data?.lead_response);
    setEditDetail(false);
  }
  
  const handleRightBar = () => {
    setOpenRightBar(false);
  }
  
  const handleSubmitLead = async (payload) => {
    let companyNameReal, companyWebsiteReal;
    const payloadNew = await payload.map((obj) => {
      // Create a new object with only the desired keys
      if (obj.type === "company") {
        setCompanyName(obj.values);
        companyNameReal = obj.values
      }
      if (obj.type === "company_website") {
        setCompanyWebsite(obj.values);
        companyWebsiteReal = obj.values
      }
      if (obj?.options?.length > 0) {
        obj.values = obj?.values?.id?.toString() || null;
        obj.options = [];
      }
      const { id, display, ...rest } = obj;
      return rest;
    });
    let stageNum = await payloadNew.filter((item) => {
      if (item.type !== "calender") {
        return item;
      }
    });
    await dispatch(editUserData(authToken, id, stageNum, companyNameReal, companyWebsiteReal));
    setEditDetail(false);
  }
  
  const handleDynamicFields = async (e, id, type, len) => {
    let data = [...user_detail_left];
    await data.map((obj) => {
      if (id === null && obj.display === "Name") {
        obj.values = e.target.value;
        setName(e.target.value);
      }
      if ((type === "company" || type === "account_name") && (obj.type === "company" || obj.type === "account_name")) {
        obj.values = e.target.value;
      }
      if ((type === "company_website" || type === "account_website") && (obj.type === "company_website" || obj.type === "account_website")) {
        obj.values = e.target.value;
      }
      if (id === obj.id && len === 0) {
        obj.values = e.target.value;
      }
      if (id === obj.id && len !== 0) {
        obj.values = e;
      }
      return obj;
    });
    setUserData(data);
  }

  return (
    <>
      {isLoading && <Loading />}
      {userDetails !== null && (
        <div className="detailed-lead pt-[4rem] grid grid-cols-12">
          <div className="col-span-3 max-sm:col-span-12 px-6">
            {" "}
            <div className="mt-4">
              <div className="mt-2 flex cursor-pointer">
                <Icon.ChevronLeft
                  onClick={handleRoute}
                  className="py-1"
                  style={{
                    fontSize: 25,
                    color: "#6B7280",
                    fontWeight: "bold",
                  }}
                />
                <div onClick={handleRoute} className="my-auto text-sm leading-5 font-medium text-gray-500">
                  Leads
                </div>
                {editDetail !== true ? <>
                  <span onClick={()=>{handleEditorStatus(true)}} className="flex ml-auto mr-0 items-center justify-center border hover:text-[var(--brand-primary)] hover:border-[var(--brand-primary)] border-gray-300 px-2.5 py-1 rounded-md border-solid cursor-pointer ">
                    <Icon.Pencil className="cursor-pointer text-gray-600 text-[16px]" />
                  </span>
                </>
                :
                <>
                  <span onClick={backToDetail} className="flex ml-auto mr-1 items-center justify-center border hover:text-[var(--brand-primary)] border-[gray] px-2.5 py-1 rounded-md border-solid cursor-pointer ">
                    <Icon.X className="cursor-pointer text-[gray] text-[16px]" />
                  </span>
                    <span onClick={() => { handleSubmitLead(userData) }} className="flex items-center justify-center border hover:text-[var(--brand-primary)] border-[green] px-2.5 py-1 rounded-md border-solid cursor-pointer ">
                    <Icon.Check2 className="cursor-pointer text-[green] text-[16px]" />
                  </span>
                </>
                }
              </div>
              <div className="mt-2">
                <div className="flex items-center">
                  <div className="mr-2">
                    <div className="circle">
                      {getChars(name || userDetails?.data?.response?.name || "Unknown")}
                    </div>
                  </div>
                  <div className="pt-1 max-sm:ml-3 max-sm:border-none max-sm:border-white">
                    {/* Lead Name */}
                      <div
                        className={
                          "details-input-parent " + (editDetail && "w-100")
                        }
                      >
                        {editDetail !== true ? (
                          <div className="h-[35px] w-[200px] text-2xl capitalize leading-9 font-semibold overflow-hidden text-ellipsis whitespace-nowrap text-gray-900">
                            {name}
                          </div>
                        ) : (
                          <div className="first-div h-[35px]">
                            <div>
                              <input
                                className="text-2xl leading-9 font-semibold text-gray-900 w-[80%]"
                                type="text"
                                value={name}
                                onChange={(e) => {
                                  handleDynamicFields(e, null);
                                }}
                                autoFocus
                              />
                            </div>
                          </div>
                        )}
                      </div>
                  </div>
                  <div onClick={()=>{setOpenRightBar(true);}} className="animate-pulse sm:hidden bg-[var(--brand-primary)] p-2 rounded-[10px] ml-auto mr-0">
                    <Icon.GraphUpArrow className="text-[22px] text-[#ffffff]" />
                  </div>
                </div>
              </div>
              <TabLeadDetail tabs={tabs} setTabName={setTabName} tabName={tabName} />
              <hr className="mt-0 max-sm:hidden" />
              <div className="h-[50vh] listing max-sm:border-b max-sm:border-t max-sm:border-gray-200 overflow-y-auto max-sm:h-[20vh]">
                {/* Lead Email */}
                {tabName === "Lead" ? <>
                {userData?.length > 0 && userData.map((data, d_index)=>{
                    return (
                      <>{(data.display !== "Name" && data.display !== "Calender" && data.object_type === "leads" && (editDetail !== false || (data.values && data.values !== "" && data.values !== null))) && <div className="mt-3 lh-lg details-section">
                        <div className="text-xs leading-4 font-normal text-gray-700">
                          {data.display}
                        </div>
                        <div
                          className="grid grid-cols-12"
                        >
                          {editDetail !== true ? (
                            <div className="h-[25px] col-span-8 text-sm leading-5 font-normal text-gray-900">
                              {data?.options?.length > 0 ? data?.values?.option_value : data.values}
                            </div>
                          ) : (
                            <div className="h-auto col-span-9 fw-normal">
                              <div>
                                {data?.options?.length === 0 ? <input
                                  className="w-full text-sm leading-5 font-normal text-gray-900"
                                  type={data.type}
                                  value={data.values}
                                  onChange={(e) => {
                                    handleDynamicFields(e, data.id, data.type, data?.options?.length);
                                  }}
                                  /> :
                                    <>
                                      <div className="w-full text-sm leading-5 font-normal text-gray-900">                                        
                                        <Listbox
                                          value={data.values}
                                          onChange={(e) => { handleDynamicFields(e, data.id, data.type, data?.options?.length) }}>
                                          {({ open }) => (
                                            <>
                                              <div className="relative">
                                                <Listbox.Button className="relative h-[25px] mr-[5px] rounded-none border-b-[#ced4da] border-b border-solid w-full bg-white text-left text-gray-900 shadow-sm focus:outline-none cursor-pointer sm:text-sm sm:leading-6">
                                                  <span className="block truncate">{data?.values?.option_value}</span>
                                                  <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                                    <ChevronDownIcon className="h-4 w-4 text-gray-400" aria-hidden="true" />
                                                  </span>
                                                </Listbox.Button>

                                                <Transition
                                                  show={open}
                                                  as={Fragment}
                                                  leave="transition ease-in duration-100"
                                                  leaveFrom="opacity-100"
                                                  leaveTo="opacity-0"
                                                >
                                                  <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-full listing overflow-auto rounded-md h-[25vh] bg-[#f5f5f5] py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                                    {data?.options?.map((option) => (
                                                      <Listbox.Option
                                                        key={option.id}
                                                        className={({ active }) =>
                                                          classNames(
                                                            active ? 'bg-[var(--brand-primary)] text-white' : 'text-gray-900',
                                                            'relative cursor-default select-none py-2 pl-2 pr-4'
                                                          )
                                                        }
                                                        value={option}
                                                      >
                                                        {({ selected, active }) => (
                                                          <>
                                                            <span className={classNames(selected ? 'font-semibold' : 'font-normal', 'block truncate')}>
                                                              {option.option_value}
                                                            </span>

                                                            {/* {selected ? (
                                                              <span
                                                                className={classNames(
                                                                  active ? 'text-white' : 'text-indigo-600',
                                                                  'absolute inset-y-0 left-0 flex items-center pl-1.5'
                                                                )}
                                                              >
                                                                <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                                              </span>
                                                            ) : null} */}
                                                          </>
                                                        )}
                                                      </Listbox.Option>
                                                    ))}
                                                  </Listbox.Options>
                                                </Transition>
                                              </div>
                                            </>
                                          )}
                                        </Listbox>
                                        
                                      </div>
                                    </>}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>}</>
                    )
                })}
                </> :
                <>
                {(userData?.length > 0 && (captureData?.company_website !== "" || captureData?.company !== "")) && userData.map((data, d_index)=>{
                    return (
                      <>{(data.display !== "Name" && data.display !== "Calender"&& data.object_type !== "leads" && (editDetail !== false || (data.values && data.values !== "" && data.values !== null))) && <div className="mt-3 lh-lg details-section">
                        <div className="text-xs leading-4 font-normal text-gray-700">
                          {data.display}
                        </div>
                        <div
                          className="grid grid-cols-12"
                        >
                          {editDetail !== true ? (
                            <div className="h-[25px] col-span-8 text-sm leading-5 font-normal text-gray-900">
                              {data?.options?.length > 0 ? data?.values?.option_value : data.values}
                            </div>
                          ) : (
                            <div className="h-auto col-span-9 fw-normal">
                              <div>
                                {data?.options?.length === 0 ? <input
                                  className="w-full text-sm leading-5 font-normal text-gray-900"
                                  type={data.type}
                                  value={data.values}
                                  onChange={(e) => {
                                    handleDynamicFields(e, data.id, data.type, data?.options?.length);
                                  }}
                                  /> :
                                    <>
                                      <div className="w-full text-sm leading-5 font-normal text-gray-900">                                        
                                        <Listbox
                                          value={data.values}
                                          onChange={(e) => { handleDynamicFields(e, data.id, data.type, data?.options?.length) }}>
                                          {({ open }) => (
                                            <>
                                              <div className="relative">
                                                <Listbox.Button className="relative h-[25px] mr-[5px] rounded-none border-b-[#ced4da] border-b border-solid w-full bg-white text-left text-gray-900 shadow-sm focus:outline-none cursor-pointer sm:text-sm sm:leading-6">
                                                  <span className="block truncate">{data?.values?.option_value}</span>
                                                  <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                                    <ChevronDownIcon className="h-4 w-4 text-gray-400" aria-hidden="true" />
                                                  </span>
                                                </Listbox.Button>

                                                <Transition
                                                  show={open}
                                                  as={Fragment}
                                                  leave="transition ease-in duration-100"
                                                  leaveFrom="opacity-100"
                                                  leaveTo="opacity-0"
                                                >
                                                  <Listbox.Options className="absolute listing z-10 mt-1 max-h-60 w-full h-[25vh] bg-[#f5f5f5] overflow-auto rounded-md py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                                    {data?.options?.map((option) => (
                                                      <Listbox.Option
                                                        key={option.id}
                                                        className={({ active }) =>
                                                          classNames(
                                                            active ? 'bg-[var(--brand-primary)] text-white' : 'text-gray-900',
                                                            'relative cursor-default select-none py-2 pl-2 pr-4'
                                                          )
                                                        }
                                                        value={option}
                                                      >
                                                        {({ selected, active }) => (
                                                          <>
                                                            <span className={classNames(selected ? 'font-semibold' : 'font-normal', 'block truncate')}>
                                                              {option.option_value}
                                                            </span>

                                                            {/* {selected ? (
                                                              <span
                                                                className={classNames(
                                                                  active ? 'text-white' : 'text-indigo-600',
                                                                  'absolute inset-y-0 left-0 flex items-center pl-1.5'
                                                                )}
                                                              >
                                                                <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                                              </span>
                                                            ) : null} */}
                                                          </>
                                                        )}
                                                      </Listbox.Option>
                                                    ))}
                                                  </Listbox.Options>
                                                </Transition>
                                              </div>
                                            </>
                                          )}
                                        </Listbox>
                                        
                                      </div>
                                    </>}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>}</>
                    )
                })}
                </>
                }
              </div>
            </div>
            <div className="max-sm:flex max-sm:justify-start">
                <hr className="my-3" />

                {/* Last Created */}
                {userDetails.data?.response?.created_date?.length > 0 && (
                  <div className="mt-3">
                    <div className="text-xs leading-4 font-normal text-gray-700">
                      Created On
                    </div>
                    <div className="text-sm leading-5 font-normal text-gray-900">
                      {userDetails.data?.response?.created_date}
                    </div>
                  </div>
                )}
                {/* Last Edited */}
                {userDetails.data?.response?.edited_date?.length > 0 && (
                  <div className="mt-3 max-sm:ml-10">
                    <div className="text-xs leading-4 font-normal text-gray-700">
                      Updated On
                    </div>
                    <div className="text-sm leading-5 font-normal text-gray-900">
                      {userDetails.data?.response?.edited_date}
                    </div>
                  </div>
                )}
              </div>
          </div>

          <div className="col-span-6 max-sm:col-span-12 bg-gray-100 ">
            <div className="setup-category">
              <div className="p-0">
                <div>
                  <ul>
                    <li
                      className={
                        window.location.pathname ===
                        `/Lead-Management/leadDetail/${id}`
                          ? "list-active"
                          : ""
                      }
                      onClick={() => {
                        navigate(`/Lead-Management/leadDetail/${id}`);
                      }}
                    >
                      <span>Detailed History</span>
                    </li>
                    {/* <li className={window.location.pathname.includes('/home/setup/microsite') ? 'list-active' : '' } onClick={() => { navigate('/setup/microsite') }}><span>Notes</span></li> */}
                    {/* <li className={window.location.pathname.includes('add-mail') ? 'list-active' : ''} onClick={() => { navigate(`/Lead-Management/leadDetail/${id}/add-mail`);}}><span>E-mails</span></li> */}
                    {/* <li className={window.location.pathname.includes('/home/setup/mobileApp') ? 'list-active' : '' } onClick={() => { navigate('/setup/mobileApp')}}><span>Meetings</span></li> */}
                    {/* <li className={window.location.pathname.includes('/home/setup/crm') ? 'list-active' : '' } onClick={() => { navigate('/setup/crm')}}><span>CRM</span></li>
                                <li className={window.location.pathname.includes('/home/setup/userManagement') ? 'list-active' : '' } onClick={() => { navigate('/setup/userManagement'); refreshPage(); }}><span>User Management</span></li> */}
                  </ul>
                </div>
              </div>
            </div>
            <div className="middlePiece">
              <Outlet></Outlet>
            </div>
            {/* <Emails />  */}

            {/* <AddMail/> */}
          </div>

          <div className="col-span-3 max-sm:hidden md:col-span-3">
            <div className="mb-1">
              <div className="w-full">
                <div className="mx-auto w-full max-w-md rounded-2xl bg-white p-2">
                  <Disclosure as="div" className="my-2">
                    {({ open }) => (
                      <>
                        <Disclosure.Button className="flex w-full justify-between rounded-lg bg-white p-3 text-left text-sm font-medium text-gray-900 hover:bg-gray-200 focus:outline-none focus-visible:ring focus-visible:ring-gray-500 focus-visible:ring-opacity-75">
                          <span className="text-[#212121] text-[12px] font-[700] leading-[16px] font-inter">
                            Insights
                          </span>
                          <ChevronUpIcon
                            className={`${
                              open ? "" : "rotate-180 transform"
                            } h-5 w-5 text-gray-500`}
                          />
                        </Disclosure.Button>
                        <Disclosure.Panel className="h-[24vh] overflow-y-auto listing">
                          <div className="flex flex-col rounded-md bg-cards p-4 mt-2">
                            <div className="flex">
                              <UserCircleIcon className="h-5 w-5" />
                              <div className="text-[#212121] font-[14px] ml-2">
                                Summary
                              </div>
                            </div>
                            <div className="text-[#212121] font-[500] text-[12px] mt-2 ml-4">
                              {((captureData?.company && captureData?.company !== "") || (captureData?.designation && captureData?.designation !== "")) && <>
                                <b>About {captureData?.name?.charAt(0).toUpperCase() + captureData?.name?.slice(1) || captureData?.email}</b> 
                                <p className="mb-3">
                                  {captureData?.company && captureData?.company !== "" && captureData?.designation && captureData?.designation !== "" ? `${captureData?.name || captureData?.email} is the “${captureData?.designation}” of “${captureData?.company}”` : (captureData?.company && captureData?.company !== "" ? `${captureData?.name || captureData?.email} is with ${captureData?.company}` : `${captureData?.name || captureData?.email} is the “${captureData?.designation}”`)}
                                </p>
                              </>}
                              
                              {insightData?.summary !== "" && <>
                                <b className="capitalize">Conversation Summary</b>
                                <p className="mb-3">{ userDetails?.data?.insight_data?.summary }</p>
                              </>}

                              <b className="capitalize">Visit, conversation and lead.</b>
                              <p className="mb-3">
                                {captureData?.name || captureData?.email} has visited <b className="font-semibold">“{ captureData?.client_data }”</b> <b className="font-semibold">{insightData?.visitors_count} time(s)</b> in the last <b className="font-semibold">{insightData?.last_days || 6} day(s)</b>.
                                They have asked <b className="font-semibold">{ insightData?.prompts_count } prompt(s)</b> on <b className="font-semibold">“ZOI”</b> across these <b className="font-semibold">{ insightData?.no_of_sessions } session(s)</b>.
                                {insightData?.avg_spent_time != "0" && <>He has spent an average of <b className="font-semibold">{insightData?.avg_spent_time} minute(s)</b> per visit.</>}
                                <br/>
                                {insightData?.engagement_ratio != "0" && <><span><b className="font-semibold">Visit to Engagement ratio :</b></span> {insightData?.engagement_ratio}%<br/></>}
                                {insightData?.engagement_to_lead_ratio != "0" && <><span><b className="font-semibold">Engagement to Lead ratio :</b></span> {insightData?.engagement_to_lead_ratio}%</>}
                              </p>
                              {capturedFields.length > 0 && <>
                                <b className="capitalize">Lead Details</b>
                                <p className="mb-3">Information shared by them with ZOI
                                  <ul>
                                    {capturedFields.map((obj) => {
                                      return (
                                        <>{obj.value !== "" && obj.key !== "client_data" && <li className={obj.key ==="name" && "capitalize"}> <span className="capitalize font-semibold">{obj.key.replace("_"," ")}</span> : { obj.value }</li>}</>
                                      );
                                    })}
                                  </ul>
                                </p>
                              </>}
                            </div>
                            {/* {userDetails?.data?.insight_data?.visitors_count > 0 && <div className="text-[#212121] font-[500] text-[12px] mt-2 ml-4">
                              <p>
                                {`${userDetails?.data?.response?.name} has visited SalesPanda ${userDetails?.data?.insight_data?.visitors_count} times.
                                  ${userDetails?.data?.response?.name} has asked ${userDetails?.data?.insight_data?.prompts_count} prompts. 
                                  ${userDetails?.data?.response?.name} has filled in his ${userDetails?.data?.insight_data?.captured_fields_count?.map((key, index) => {
                                    if (index === userDetails?.data?.insight_data?.captured_fields_count?.length-1) {
                                      return " and " + key
                                    } else {
                                      return " " + key
                                    }
                                  })}. 
                                `}                               
                              </p>
                              {(userDetails?.data?.insight_data?.visitors_summary && userDetails?.data?.insight_data?.visitors_summary !== "") && <p className="mt-2">
                                {userDetails?.data?.insight_data?.visitors_summary}
                              </p>}
                            </div>}
                            {userDetails?.data?.insight_data?.visitors_count === 0 && <div className="relative flex flex-col mt-2 rounded-md bg-cards p-4">
                              <div className="flex justify-center">
                                <div className="text-[#212121] font-[14px] ml-2">
                                  No Summary
                                </div>
                              </div>
                            </div>} */}
                          </div>
                        </Disclosure.Panel>
                      </>
                    )}
                  </Disclosure>
                  <hr />
                  <Disclosure as="div" className="my-2 relative">
                    {({ open }) => (
                      <>
                        <Disclosure.Button className="flex w-full items-center justify-between rounded-lg bg-white p-3 text-left text-sm font-medium text-purple-900 hover:bg-gray-200 focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75">
                          <span className="text-[#212121] text-[12px] font-[700] leading-[16px] font-inter">
                            Upcoming Meetings
                          </span>
                          <div className="flex">
                            <ChevronUpIcon
                              className={`${
                                open ? "" : "rotate-180 transform"
                              } h-5 w-5 text-gray-500`}
                            />
                          </div>
                        </Disclosure.Button>
                        <div className={"absolute right-[10%]" + (open ? " top-[12%] " :" top-[30%] ")}>
                          <ArrowPathIcon
                            onClick={() => {
                              dispatch(fetchUpdatedMeeting(authToken, id, setRefreshFlag));
                            }}
                            className={"h-5 w-5 cursor-pointer hover:text-[#46737a] text-[var(--brand-primary)] mr-2"+ ( refreshFlag === true ? " animate-spin ": "")}
                          />
                        </div>
                        <Disclosure.Panel className="max-h-[15vh] overflow-y-auto listing">
                          {userDetails?.data?.upcoming_meeting?.length > 0 && userDetails?.data?.upcoming_meeting.map((meet,m_index) => {
                            return (
                              <div className="relative flex flex-col mt-2 rounded-md bg-cards p-4">
                                <div className="flex">
                                  <PhoneIcon className="h-4 w-4" />
                                  <div className="text-[#212121] font-[14px] ml-2">
                                  Call scheduled
                                  </div>
                                </div>
                                <div className="text-[#212121] font-[500] text-[12px] mt-2 ml-4">
                                {meet.time}, {meet.date}
                                </div>
                                <span className="absolute capitalize text-[10px] bg-[#19945914] border text-[#199459] px-[5px] py-px rounded-md border-solid border-[#199459] right-3 top-[25%]">{ meet.duration }</span>
                              </div>
                            )
                          })}
                          {userDetails?.data?.upcoming_meeting?.length === 0 && <div className="relative flex flex-col mt-2 rounded-md bg-cards p-4">
                            <div className="flex justify-center">
                              <div className="text-[#212121] font-[14px] ml-2">
                                No Meeting Scheduled
                              </div>
                            </div>
                          </div>}
                        </Disclosure.Panel>
                      </>
                    )}
                  </Disclosure>
                  <hr />
                  <Disclosure as="div" className="my-2">
                    {({ open }) => (
                      <>
                        <Disclosure.Button className="flex w-full justify-between items-center rounded-lg bg-white p-3 text-left text-sm font-medium text-purple-900 hover:bg-gray-200 focus:outline-none focus-visible:ring focus-visible:ring-gray-500 focus-visible:ring-opacity-75">
                          <span className="text-[#212121] text-[12px] font-[700] leading-[16px] font-inter">
                            Contacts
                          </span>
                          <ChevronUpIcon
                            className={`${
                              open ? "" : "rotate-180 transform"
                            } h-5 w-5 text-gray-500`}
                          />
                        </Disclosure.Button>
                        <Disclosure.Panel className="h-[24vh] listing overflow-y-auto px-4 pt-4 pb-2 text-sm text-gray-500">
                          <div className="flex flex-wrap">
                           {userDetails?.data.list.map((contact, c_index) => {
                            return (
                              <div className="flex flex-col w-[16%] mr-3 mb-1 my-3 cursor-pointer"
                                onClick={() => {
                                  navigate(
                                    `/Lead-Management/leadDetail/${contact.id}`
                                  );
                                }}
                              >
                                <div className="rounded-full text-center bg-gray-200 p-3 text-[15.75px] leading-[13.2px] text-[#212121] font-[400] uppercase">
                                    {contact.symbol || "U"}
                                </div>
                                <div className="mt-2 text-center leading-3 text-[10px] font-[400] text-[#212121]">{contact.name || "Unknown"}</div>
                              </div>
                            )})}
                          </div>
                        </Disclosure.Panel>
                      </>
                    )}
                  </Disclosure>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Preview modal  */}
        <Transition.Root show={openRightBar} as={Fragment}>
          <Dialog as="div" className="relative z-50" onClose={handleRightBar}>
            <Transition.Child
              as={Fragment}
              enter="ease-in-out duration-500"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in-out duration-500"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed inset-0 overflow-hidden">
              <div className="absolute inset-0 overflow-hidden">
                <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
                  <Transition.Child
                    as={Fragment}
                    enter="transform transition ease-in-out duration-500 sm:duration-700"
                    enterFrom="translate-x-full"
                    enterTo="translate-x-0"
                    leave="transform transition ease-in-out duration-500 sm:duration-700"
                    leaveFrom="translate-x-0"
                    leaveTo="translate-x-full"
                  >
                    <Dialog.Panel className="pointer-events-auto relative w-screen max-w-lg">
                      <Transition.Child
                        as={Fragment}
                        enter="ease-in-out duration-500"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in-out duration-500"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                      >
                        <div className="absolute left-0 top-0 -ml-8 flex pr-2 pt-4 sm:-ml-10 sm:pr-4">
                          <button
                            type="button"
                            className="relative rounded-md text-gray-300 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                            onClick={handleRightBar}
                          >
                            <span className="absolute -inset-2.5" />
                            <span className="sr-only">Close panel</span>
                            <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                          </button>
                        </div>
                      </Transition.Child>
                        <div className="flex h-full flex-col p-0 bg-white shadow-xl">
                          <div className="relative flex-1 px-0 sm:px-0">
                              <div className="col-span-12">
                                  <div className="mb-1">
                                    <div className="w-full">
                                      <div className="mx-auto w-full max-w-md rounded-2xl bg-white p-2">
                                        <Disclosure as="div" className="my-2">
                                          {({ open }) => (
                                            <>
                                              <Disclosure.Button className="flex w-full justify-between rounded-lg bg-white p-3 text-left text-sm font-medium text-gray-900 hover:bg-gray-200 focus:outline-none focus-visible:ring focus-visible:ring-gray-500 focus-visible:ring-opacity-75">
                                                <span className="text-[#212121] text-[12px] font-[700] leading-[16px] font-inter">
                                                  Insights
                                                </span>
                                                <ChevronUpIcon
                                                  className={`${
                                                    open ? "" : "rotate-180 transform"
                                                  } h-5 w-5 text-gray-500`}
                                                />
                                              </Disclosure.Button>
                                              <Disclosure.Panel className="h-[24vh] overflow-y-auto listing">
                                                <div className="flex flex-col rounded-md bg-cards p-4 mt-2">
                                                  <div className="flex">
                                                    <UserCircleIcon className="h-5 w-5" />
                                                    <div className="text-[#212121] font-[14px] ml-2">
                                                      Summary
                                                    </div>
                                                  </div>
                                                  <div className="text-[#212121] font-[500] text-[12px] mt-2 ml-4">
                                                    {((captureData?.company && captureData?.company !== "") || (captureData?.designation && captureData?.designation !== "")) && <>
                                                      <b>About {captureData?.name?.charAt(0).toUpperCase() + captureData?.name?.slice(1) || captureData?.email}</b> 
                                                      <p className="mb-3">
                                                        {captureData?.company && captureData?.company !== "" && captureData?.designation && captureData?.designation !== "" ? `${captureData?.name || captureData?.email} is the “${captureData?.designation}” of “${captureData?.company}”` : (captureData?.company && captureData?.company !== "" ? `${captureData?.name || captureData?.email} is with ${captureData?.company}` : `${captureData?.name || captureData?.email} is the “${captureData?.designation}”`)}
                                                      </p>
                                                    </>}
                                                    
                                                    {insightData?.summary !== "" && <>
                                                      <b className="capitalize">Conversation Summary</b>
                                                      <p className="mb-3">{ userDetails?.data?.insight_data?.summary }</p>
                                                    </>}

                                                    <b className="capitalize">Visit, conversation and lead.</b>
                                                    <p className="mb-3">
                                                      {captureData?.name || captureData?.email} has visited <b className="font-semibold">“{ captureData?.client_data }”</b> <b className="font-semibold">{insightData?.visitors_count} time(s)</b> in the last <b className="font-semibold">{insightData?.last_days || 6} day(s)</b>.
                                                      They have asked <b className="font-semibold">{ insightData?.prompts_count } prompt(s)</b> on <b className="font-semibold">“ZOI”</b> across these <b className="font-semibold">{ insightData?.no_of_sessions } session(s)</b>.
                                                      {insightData?.avg_spent_time != "0" && <>He has spent an average of <b className="font-semibold">{insightData?.avg_spent_time} minute(s)</b> per visit.</>}
                                                      <br/>
                                                      {insightData?.engagement_ratio != "0" && <><span><b className="font-semibold">Visit to Engagement ratio :</b></span> {insightData?.engagement_ratio}%<br/></>}
                                                      {insightData?.engagement_to_lead_ratio != "0" && <><span><b className="font-semibold">Engagement to Lead ratio :</b></span> {insightData?.engagement_to_lead_ratio}%</>}
                                                    </p>
                                                    {capturedFields.length > 0 && <>
                                                      <b className="capitalize">Lead Details</b>
                                                      <p className="mb-3">Information shared by them with ZOI
                                                        <ul>
                                                          {capturedFields.map((obj) => {
                                                            return (
                                                              <>{obj.value !== "" && obj.key !== "client_data" && <li className={obj.key ==="name" && "capitalize"}> <span className="capitalize font-semibold">{obj.key.replace("_"," ")}</span> : { obj.value }</li>}</>
                                                            );
                                                          })}
                                                        </ul>
                                                      </p>
                                                    </>}
                                                  </div>
                                                  {/* {userDetails?.data?.insight_data?.visitors_count > 0 && <div className="text-[#212121] font-[500] text-[12px] mt-2 ml-4">
                                                    <p>
                                                      {`${userDetails?.data?.response?.name} has visited SalesPanda ${userDetails?.data?.insight_data?.visitors_count} times.
                                                        ${userDetails?.data?.response?.name} has asked ${userDetails?.data?.insight_data?.prompts_count} prompts. 
                                                        ${userDetails?.data?.response?.name} has filled in his ${userDetails?.data?.insight_data?.captured_fields_count?.map((key, index) => {
                                                          if (index === userDetails?.data?.insight_data?.captured_fields_count?.length-1) {
                                                            return " and " + key
                                                          } else {
                                                            return " " + key
                                                          }
                                                        })}. 
                                                      `}                               
                                                    </p>
                                                    {(userDetails?.data?.insight_data?.visitors_summary && userDetails?.data?.insight_data?.visitors_summary !== "") && <p className="mt-2">
                                                      {userDetails?.data?.insight_data?.visitors_summary}
                                                    </p>}
                                                  </div>}
                                                  {userDetails?.data?.insight_data?.visitors_count === 0 && <div className="relative flex flex-col mt-2 rounded-md bg-cards p-4">
                                                    <div className="flex justify-center">
                                                      <div className="text-[#212121] font-[14px] ml-2">
                                                        No Summary
                                                      </div>
                                                    </div>
                                                  </div>} */}
                                                </div>
                                              </Disclosure.Panel>
                                            </>
                                          )}
                                        </Disclosure>
                                        <hr />
                                        <Disclosure as="div" className="my-2 relative">
                                          {({ open }) => (
                                            <>
                                              <Disclosure.Button className="flex w-full items-center justify-between rounded-lg bg-white p-3 text-left text-sm font-medium text-purple-900 hover:bg-gray-200 focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75">
                                                <span className="text-[#212121] text-[12px] font-[700] leading-[16px] font-inter">
                                                  Upcoming Meetings
                                                </span>
                                                <div className="flex">
                                                  <ChevronUpIcon
                                                    className={`${
                                                      open ? "" : "rotate-180 transform"
                                                    } h-5 w-5 text-gray-500`}
                                                  />
                                                </div>
                                              </Disclosure.Button>
                                              <div className={"absolute right-[10%]" + (open ? " top-[12%] " :" top-[30%] ")}>
                                                <ArrowPathIcon
                                                  onClick={() => {
                                                    dispatch(fetchUpdatedMeeting(authToken, id, setRefreshFlag));
                                                  }}
                                                  className={"h-5 w-5 cursor-pointer hover:text-[#46737a] text-[var(--brand-primary)] mr-2"+ ( refreshFlag === true ? " animate-spin ": "")}
                                                />
                                              </div>
                                              <Disclosure.Panel className="max-h-[15vh] overflow-y-auto listing">
                                                {userDetails?.data?.upcoming_meeting?.length > 0 && userDetails?.data?.upcoming_meeting.map((meet,m_index) => {
                                                  return (
                                                    <div className="relative flex flex-col mt-2 rounded-md bg-cards p-4">
                                                      <div className="flex">
                                                        <PhoneIcon className="h-4 w-4" />
                                                        <div className="text-[#212121] font-[14px] ml-2">
                                                        Call scheduled
                                                        </div>
                                                      </div>
                                                      <div className="text-[#212121] font-[500] text-[12px] mt-2 ml-4">
                                                      {meet.time}, {meet.date}
                                                      </div>
                                                      <span className="absolute capitalize text-[10px] bg-[#19945914] border text-[#199459] px-[5px] py-px rounded-md border-solid border-[#199459] right-3 top-[25%]">{ meet.duration }</span>
                                                    </div>
                                                  )
                                                })}
                                                {userDetails?.data?.upcoming_meeting?.length === 0 && <div className="relative flex flex-col mt-2 rounded-md bg-cards p-4">
                                                  <div className="flex justify-center">
                                                    <div className="text-[#212121] font-[14px] ml-2">
                                                      No Meeting Scheduled
                                                    </div>
                                                  </div>
                                                </div>}
                                              </Disclosure.Panel>
                                            </>
                                          )}
                                        </Disclosure>
                                        <hr />
                                        <Disclosure as="div" className="my-2">
                                          {({ open }) => (
                                            <>
                                              <Disclosure.Button className="flex w-full justify-between items-center rounded-lg bg-white p-3 text-left text-sm font-medium text-purple-900 hover:bg-gray-200 focus:outline-none focus-visible:ring focus-visible:ring-gray-500 focus-visible:ring-opacity-75">
                                                <span className="text-[#212121] text-[12px] font-[700] leading-[16px] font-inter">
                                                  Contacts
                                                </span>
                                                <ChevronUpIcon
                                                  className={`${
                                                    open ? "" : "rotate-180 transform"
                                                  } h-5 w-5 text-gray-500`}
                                                />
                                              </Disclosure.Button>
                                              <Disclosure.Panel className="h-[24vh] listing overflow-y-auto px-4 pt-4 pb-2 text-sm text-gray-500">
                                                <div className="flex flex-wrap">
                                                {userDetails?.data.list.map((contact, c_index) => {
                                                  return (
                                                    <div className="flex flex-col w-[16%] mr-3 mb-1 my-3 cursor-pointer"
                                                      onClick={() => {
                                                        navigate(
                                                          `/Lead-Management/leadDetail/${contact.id}`
                                                        );
                                                      }}
                                                    >
                                                      <div className="rounded-full text-center bg-gray-200 p-3 text-[15.75px] leading-[13.2px] text-[#212121] font-[400] uppercase">
                                                          {contact.symbol || "U"}
                                                      </div>
                                                      <div className="mt-2 text-center leading-3 text-[10px] font-[400] text-[#212121]">{contact.name || "Unknown"}</div>
                                                    </div>
                                                  )})}
                                                </div>
                                              </Disclosure.Panel>
                                            </>
                                          )}
                                        </Disclosure>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                          </div>
                        </div>
                    </Dialog.Panel>
                  </Transition.Child>
                </div>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
    </>
  );
};

export default LeadDetail;
